import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfinityScrollComponent } from './infinity-scroll/infinity-scroll.component';
import { CardsModule } from '../bloques/cards.module';
import { LottieModule } from 'ngx-lottie';
import { OtpVerificationComponent } from './otp-verification/otp-verification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CardSelectComponent } from './card-select/card-select.component';

@NgModule({
  declarations: [InfinityScrollComponent, OtpVerificationComponent, CardSelectComponent],
  imports: [
    CommonModule,
    CardsModule,
    LottieModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [InfinityScrollComponent, CardSelectComponent],
})
export class SharedModule {}
